
import {
    Component,
    Vue
} from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import MaterialSelect from "@/components/material-select/index.vue";
import UploadVoucher from '../components/upload-voucher.vue'
import {
    apiOrderDetail,
    apiOrderRemarks,
} from '@/api/order'
@Component({
    components: {
        LsDialog,
        MaterialSelect,
        UploadVoucher
    }
})
export default class OrderDetail extends Vue {
    // S Data
    showPay = false
    // รายละเอียดการสั่งซื้อID
    id: any = 0

    // ข้อมูลการสั่งซื้อ
    orderData: any = {

    }
    voucher = []

    // ข้อสังเกตของผู้ขาย
    remarks: String = ''

    // E Data

    // S Methods
    // รับรายละเอียดการสั่งซื้อ
    getOrderDetail() {
        apiOrderDetail({
            set_meal_order_id: this.id
        }).then(res => {
            this.orderData = res
        })
    }




    // ข้อสังเกตของผู้ขาย
    postOrderRemarks() {
        apiOrderRemarks({
            set_meal_order_id: this.id,
            remark: this.remarks
        }).then(res => {
            this.getOrderDetail()
        })
    }

    // E Methods

    created() {
        this.id = this.$route.query.id
        this.id && this.getOrderDetail()
    }
}
